export default {
  message: {
    "error": "ups! Etwas ist schiefgegangen.",
    "Sorrysomeerrorsoccurred": "Ein unerwarteter Fehler ist aufgetreten. Sie können versuchen, die Sprache zu wechseln oder die App zu schließen und neu zu starten.",
    "quit": "Beenden",
    "language": "Sprache",
    "Youcanchangethelanguagehere": "Sie können die Sprache hier ändern!",
    "current": "Aktuell",
    "home": "Startseite",
    "friends": "Freunde",
    "wallet": "Wallet",
    "aboutus": "Über uns",
    "Sharewithfriends": "Mit Freunden teilen",
    "copyFailure": "Kopieren fehlgeschlagen",
    "copySuccess": "Erfolg beim Kopieren",
    "Claimreward": "Belohnung erhalten",
    "DailyLogin": "Tägliche Anmeldung",
    "noInvitationsYet": "Noch keine Einladungen",
    "LoadMore": "Mehr laden",
    "WatchAD": "Werbung ansehen",
    "continue": "Fortfahren",
    "Congratulations": "Herzlichen Glückwunsch",
    "MyFriends": "Meine Freunde",
    "Invitefriends": "Freunde einladen",
    "Invitepremiumfriends": "Premium-Freunde einladen",
    "DailyTasks": "Tägliche Aufgaben",
    "inviteDesc": "+{num} ${name} für jeden Freund, den Sie einladen",
    "DailyTasksDesc": "Schließe Aufgaben ab, um mehr Airdrops zu erhalten",
    "SponsorsandPartners": "Sponsoren und Partner",
    "Receivingwallet": "Empfangende Wallet",
    "Enterwalletaddress": "{name} Wallet-Adresse eingeben",
    "Claim": "Belohnung erhalten",
    "Booster": "Booster",
    "RentPeriod": "Mietzeitraum",
    "days30": "30 Tage",
    "Dailyprofit": "Täglicher Gewinn",
    "Totalprofit": "Gesamtgewinn",
    "Quantity": "Menge",
    "RentPrice": "Mietpreis",
    "RentMiner": "Miner mieten",
    "Insufficient": "Nicht genügend Eingeladene",
    "InsufficientMsg": "Sie müssen {num} Freunde einladen, um mehr Zubehör zu verdienen.",
    "Settings": "Einstellungen",
    "copyid": "ID kopieren",
    "UpgradeSuccessfully": "Erfolgreich upgraden",
    "Name": "Name",
    "userinfo": "Benutzerinfo",
    "disconnect": "Trennen",
    "Startmining": "Mining starten",
    "Welcome": "Willkommen bei {name}",
    "Withdrawal": "Abhebung",
    "Minimumamount": "Minimale Menge",
    "Networkfee": "Netzgebühr",
    "Enteramount": "Betrag eingeben",
    "Submit": "Einreichen",
    "MinimumTip": "Der Abhebungsbetrag ist zu klein. Mindestabhebungsbetrag: {num}",
    "MaximumTip": "Unzureichender Betrag, der maximale Betrag, den Sie abheben können, beträgt: {num}",
    "SubmittedTip": "Einreichung erfolgt, wird voraussichtlich innerhalb von 30-60 Werktagen bearbeitet",
    "WebSubmittedTip": "Einreichung erfolgt, wir werden es so schnell wie möglich bearbeiten.",
    "WithdrawStatus": "Status",
    "Submissiontime": "Einreichungszeit",
    "WithdrawAwaitTip": "* Es wird geschätzt, dass es 30-60 Werktage dauert. Mehr Freunde einzuladen kann den Überprüfungsprozess beschleunigen.",
    "WebWithdrawAwaitTip": "* Es wird geschätzt, dass es 24-48 Stunden dauert. Mehr Freunde einzuladen kann den Überprüfungsprozess beschleunigen.",
    "Processing": "Bearbeitung",
    "Success": "Erfolg",
    "Rejection": "Ablehnung",
    "Amount": "Betrag",
    "Numberoffriends": "Anzahl der Freunde: {now}/{limit}",
    "InviteTip": "Um Ihre erste Abhebung zu tätigen, müssen Sie {limit} Freunde einladen, um der Mining-App beizutreten.",
    "openonphone": "Öffnen Sie diesen Link auf Ihrem Handy.",
    "claimTip": "Der Betrag zum Einfordern ist zu klein. Der Mindestbetrag zum Einfordern beträgt: {num}",
    "WalletBalance": "Wallet-Balance",
    "Withdraw": "Abheben",
    "SetWalletAddress": "Wallet-Adresse festlegen",
    "WithdrawalRecord": "Abhebungsprotokoll",
    "Norecords": "Keine Protokolle",
    "Whatis": "Was ist {name}?",
    "All": "Alle",
    "save": "Speichern",
    "successWithdrawal": "Scan erfolgreich {num}",
    "secondsago": "vor {time} Sekunden",
    "Loading": "Lade...",
    "PaymentConfirming": "Transaktionsstatus wird überprüft...",
    "Check": "Überprüfen",
    "CheckFail": "Transaktion nicht abgeschlossen. Bitte in 5 Sekunden erneut prüfen.",
    "Addname": "'{name}' zu Ihrem Namen hinzufügen",
    "Restattcheck": "App neu starten, um zu überprüfen",
    "Copyname": "'{name}' kopieren",
    "SubmissionFailed": "Einreichung fehlgeschlagen, bitte später erneut versuchen",
    "WithdrawalReview": "Abhebungsüberprüfung",
    "select_payment_method": "Zahlungsmethode auswählen",
    "total_amount": "Gesamtbetrag",
    "next_step": "Nächster Schritt",
    "creating_order": "Bestellung wird erstellt...",
    "order_created": "Bestellung erstellt",
    "order_status": "Bestellstatus",
    "order_id": "Bestell-ID",
    "order_amount": "Bestellbetrag",
    "order_status_desc": "Beschreibung des Bestellstatus",
    "payment_cancelled": "Zahlung storniert",
    "opening_payment": "Zahlung wird geöffnet...",
    "payment_success": "Zahlung erfolgreich",
    "payment_failed": "Zahlung fehlgeschlagen",
    "payment_pending": "Zahlung ausstehend",
    "payment_processing": "Zahlung wird bearbeitet",
    "create_order_failed": "Bestellung erstellen fehlgeschlagen",
    "creating_ton_order": "TON-Bestellung wird erstellt...",
    "check_payment_status": "Zahlungsstatus wird überprüft...",
    "use_ton_payment": "TON-Zahlung verwenden",
    "connect_wallet": "Wallet verbinden",
    "start_transaction": "Transaktion starten",
    "address": "Adresse",
    "amount_ton": "Betrag TON",
    "copy": "Kopieren",
    "comment_memo": "Kommentar Notiz",
    "comment_memo_desc": "Bitte geben Sie die Kommentar Notiz ein",
    "comment_memo_placeholder": "Kommentar Notiz eingeben",
    "amount": "Betrag",
    "wallet_address": "Wallet-Adresse",
    "you_can_choose_to_connect_wallet_to_pay": "Sie können wählen, die Wallet zur Zahlung zu verbinden",
    "or_manually_transfer_to_the_above_address": "Oder manuell an die obige Adresse überweisen (beachten Sie, dass der Betrag und die Notiz genau gleich sein müssen)",
    "transaction_success": "Transaktion erfolgreich",
    "transaction_failed": "Transaktion fehlgeschlagen",
    "transaction_error": "Transaktionsfehler",
    "transaction_status": "Transaktionsstatus",
    "transaction_id": "Transaktions-ID",
    "transaction_amount": "Transaktionsbetrag",
    "transaction_status_desc": "Beschreibung des Transaktionsstatus",
    "miner_detail": "Miner-Details",
    "rent_period": "Mietdauer",
    "days": "{days} Tage",
    "daily_yield": "Täglicher Ertrag",
    "total_yield": "Gesamtertrag",
    "invite_friends": "1Freunde einladen",
    "price": "Preis",
    "rent": "Mieten",
    "free_claim": "Freie Belohnung",
    "redeem": "Einlösen",
    "buy": "Mieten",
    "invite_friends_not_enough": "Freunde einladen nicht ausreichend",
    "redeem_success": "Einlösen erfolgreich",
    "redeem_failed": "Einlösen fehlgeschlagen",
    "rent_success": "Miete erfolgreich",
    "rent_failed": "Miete fehlgeschlagen",
    "TotalPower": "Gesamte Leistung",
    "MaxQuantity": "Maximaler Wert erreicht",
    "Running": "Wird ausgeführt",
    "Stop": "Stoppen",
    "Withdrawalunlock": "Abhebungsfreigabe",
    "Close": "Schließen",
    "Delivering": "Lieferung",
    "Duetothelargenumber": "Aufgrund der großen Anzahl von Empfängern wird Ihr Airdrop innerhalb von 15-20 Werktagen ankommen",
    "WithdrawalunlockTip": "Sie benötigen {num} eingeladene Freunde, um Aufgaben abzuschließen/Wallets zu verknüpfen, um die Abhebung freizuschalten",
    "mining_title": "Roboter",
    "Upgrade": "Upgrade",
    "partner": "Partner",
    "faq": "Häufige Fragen",
    "task": "Aufgabe",
    "OpenRobot": "Robot Öffnen",
    "MyRobot": "Mein Robot",
    "Level": "Level",
    "Commission": "Provision",
    "DirectFriends": "Direkte Freunde",
    "Feedback": "Feedback",
    "Pleaseenteryouremailaddress": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "Inputfeedbackcontent": "Feedback-Inhalt eingeben",
    "Submitfeedback": "Feedback einreichen",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Feedback erfolgreich eingereicht, vielen Dank für Ihr wertvolles Feedback",
    "Feedbacksubmissionfailed,pleaseretriy": "Einreichung des Feedbacks fehlgeschlagen, bitte versuchen Sie es erneut",
    "Addressformaterror": "Adressformatfehler",
    "Readclipboardfailed": "Zwischenablage lesen fehlgeschlagen",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Sie haben heute bereits Feedback gegeben, bitte kommen Sie morgen wieder",
    "Record": "Aufzeichnung",
    "Newuserguidance": "Willkommenstour ansehen",
    "Usetonwallet": "TON-Wallet verwenden",
    "Reward": "Belohnung",
    "Connectwallet": "Wallet verbinden",
    "Notconnected": "Nicht verbunden",
    "Disconnect": "Trennen",
    "AboutTAI": "Token-Details",
    "WithdrawalRecordDesc": "Auszahlungsaufzeichnungen",
    "StartAItrading": "AI-Handel starten",
    "Next": "Weiter",
    "Start": "Starten",
    "WithdrawalSuccess": "Auszahlung erfolgreich",
    "WithdrawalFail": "Auszahlung fehlgeschlagen",
    "Max": "Max",
    "WithdrawalRecords": "Auszahlungsaufzeichnungen",
    "Commissionrules": "Provisionsregeln",
    "Mycommission": "Meine Provision",
    "Shop": "Shop",
    "BuyDifferentAIrobots": "Upgrade mit Rechen Geräten für schnellere Scans!",
    "CurrentRunningAIrobots": "Aktuell laufende KI-Roboter",
    "DailyProfit": "Täglicher Profit",
    "Buy": "Kaufen",
    "ValidityPeriod": "Gültigkeitsdauer",
    "Days": "Tage",
    "Price": "Preis",
    "APY": "APY",
    "NoRobot": "Keine Rechenleistung",
    "RemainingTime": "Verbleibende Zeit",
    "InviteandEarn": "Einladen und verdienen",
    "InvitDec": "Invite deine Freunde, um am KI-Handel teilzunehmen und gemeinsam USDT-Provisionen und Airdrop-Token zu verdienen!",
    "ShareToGroups": "In Gruppen teilen",
    "Select_payment_method": "Zahlungsmethode wählen",
    "twa_pay_tip_with_memo": "Bitte stellen Sie sicher, dass die Adresse, der Betrag und die Notiz für die Übertragung übereinstimmen.",
    "twa_pay_tip": "Bitte stellen Sie sicher, dass die Adresse und der Betrag für die Übertragung korrekt sind.",
    "twa_pay_tip_placeholder": "Kommentarmemo eingeben",
    "twa_pay_tip_placeholder_with_memo": "Kommentarmemo mit Memo eingeben",
    "twa_pay_tip_placeholder_without_memo": "Kommentarmemo ohne Memo eingeben",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Kommentarmemo mit Memo eingeben",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Kommentarmemo ohne Memo eingeben",
    "realtime_ai": "Echtzeit-KI-Handel",
    "check_transaction_status": "Transaktionsstatus überprüfen",
    "transaction_wait": "Die Transaktion wird verarbeitet. Sie können die App verlassen. Eine Nachricht wird Sie benachrichtigen, wenn sie abgeschlossen ist.",
    "Pleaseenteravalidemailaddress": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "max_robot_tip": "Kaufgrenze erreicht — versuchen Sie einen anderen Plan, um weiter zu handeln!",
    "connectFailure": "Verbindung zur Wallet fehlgeschlagen",
    "connectSuccess": "Verbindung zur Wallet erfolgreich",
    "PayNow": "Jetzt bezahlen",
    "min_withdrawal_amount": "Der Mindestbetrag für die Abhebung beträgt {num} {coin_name}",
    "max_withdrawal_amount": "Der Höchstbetrag für die Abhebung beträgt {num} {coin_name}",
    "balance_not_enough": "Sie haben nicht genügend Guthaben für diese Abhebung.",
    "Numberofgroups": "Anzahl der Gruppen: {now}/{limit}",
    "Withdraw_success": "Abhebung erfolgreich",
    "allProfit": "Gesamtgewinn",
    "AnnualProfit": "Jährlicher Gewinn",
    "ScanWallet": "Wallet scannen",
    "wallet_check": "wallet_check",
    "Found": "Gefunden",
    "ScanSpeed": "Scan-Geschwindigkeit",
    "MyComputingPower": "Rechnen",
    "Scanning": "Scannen!",
    "WithdrawDetail": "Abhebungsdetails",
    "ScanSuccess": "Ihre Erfolgsquote beim Scannen ist gestiegen!",
    "TaskDescription": "Erledige Aufgaben, um deine Scan-Erfolgsquote zu erhöhen!",
    "InitializingMiningSystem": "Scan-System wird initialisiert...",
    "NoWithdrawalRecord": "Kein Abhebungsnachweis",
    "Invite": "Benötigte Einladungen",
    "Free": "Kostenlos",
    "Confirm": "Bestätigen",
    "RefreshTasks": "Aufgaben aktualisieren",
    "NumberofGroups": "Anzahl der Gruppen: {now}/{limit}",
    "SendMessage": "Nachricht senden",
    "NumberofShares": "Anzahl der Anteile: {now}/{limit}",
    "NumberofTasks": "Anzahl der Aufgaben: {now}/{limit}",
    "CompleteTask": "Aufgabe abschließen",
    "Accelerated": "Beschleunigt",
    "Accelerated_withdrawals_success": "Beschleunigte Auszahlungen erfolgreich",
    "GoBuy": "Kaufen",
    "SpeedUpScan": "Beschleunigen",
    "Earnings": "Einnahmen",
    "learnMore": "Erfahren Sie mehr",
    "claimSuccess": "Belohnungen erfolgreich erhalten",
    "claimFailed": "Erhalt fehlgeschlagen, bitte versuchen Sie es erneut",
    "noDividends": "Keine Dividenden zum Einfordern",
    "dividendsInfoFallback": "Laden Sie Freunde ein, um Empfehlungsbelohnungen zu verdienen"
}};